
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/weinkauf",
      function () {
        return require("private-next-pages/weinkauf/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/weinkauf"])
      });
    }
  